import l01 from "./57.webp.asset.json";
import l02 from "./lv.webp.asset.json";
import l03 from "./78.webp.asset.json";
import l04 from "./67.webp.asset.json";
import l05 from "./66.webp.asset.json";
import l06 from "./64.webp.asset.json";
import l07 from "./63.webp.asset.json";
import l08 from "./62.webp.asset.json";
import l09 from "./60.webp.asset.json";
import l10 from "./59.webp.asset.json";
import l11 from "./41.webp.asset.json";
import l12 from "./54.webp.asset.json";
import l13 from "./53.webp.asset.json";
import l14 from "./50.webp.asset.json";
import l15 from "./48.webp.asset.json";
import l16 from "./47.webp.asset.json";
import l17 from "./46.webp.asset.json";
import l18 from "./44.webp.asset.json";
import l19 from "./43.webp.asset.json";
import l20 from "./42.webp.asset.json";
import l21 from "./40.webp.asset.json";
import l22 from "./39.webp.asset.json";
import l23 from "./37.webp.asset.json";
import l24 from "./36.webp.asset.json";
import l25 from "./35.webp.asset.json";
import l26 from "./31.webp.asset.json";
import l27 from "./30.webp.asset.json";
import l28 from "./29.webp.asset.json";
import l29 from "./28.webp.asset.json";
import l30 from "./27.webp.asset.json";
import l31 from "./26.webp.asset.json";
import l32 from "./25.webp.asset.json";
import l33 from "./24.webp.asset.json";
import l34 from "./19.webp.asset.json";
import l35 from "./17.webp.asset.json";
import l36 from "./16.webp.asset.json";

export const TRUSTED_LOGOS: { src: string; alt: string }[] = [
  { src: l01.url, alt: "Qatar Airways" },
  { src: l02.url, alt: "Louis Vuitton" },
  { src: l03.url, alt: "Canva" },
  { src: l04.url, alt: "Stockland" },
  { src: l05.url, alt: "Nakheel" },
  { src: l06.url, alt: "Vinhomes" },
  { src: l07.url, alt: "CapitaLand" },
  { src: l08.url, alt: "Emaar" },
  { src: l09.url, alt: "Ecopark" },
  { src: l10.url, alt: "Binghatti" },
  { src: l11.url, alt: "Alfa Romeo" },
  { src: l12.url, alt: "Volkswagen" },
  { src: l13.url, alt: "VinFast" },
  { src: l14.url, alt: "Renault" },
  { src: l15.url, alt: "Mercedes-Benz" },
  { src: l16.url, alt: "Lexus" },
  { src: l17.url, alt: "Honda" },
  { src: l18.url, alt: "Ducati" },
  { src: l19.url, alt: "BMW" },
  { src: l20.url, alt: "BYD" },
  { src: l21.url, alt: "Audi" },
  { src: l22.url, alt: "Kiro+" },
  { src: l23.url, alt: "Vantage Point" },
  { src: l24.url, alt: "StripeAround" },
  { src: l25.url, alt: "Stonegate" },
  { src: l26.url, alt: "Emanuele Group" },
  { src: l27.url, alt: "Ecosense" },
  { src: l28.url, alt: "BMD" },
  { src: l29.url, alt: "Biotisk" },
  { src: l30.url, alt: "Avalanche" },
  { src: l31.url, alt: "Auria" },
  { src: l32.url, alt: "MMS" },
  { src: l33.url, alt: "Fix.studio" },
  { src: l34.url, alt: "HCF" },
  { src: l35.url, alt: "GMHBA" },
  { src: l36.url, alt: "AAMI" },
];